import { useNavigate } from "react-router-dom";

const EmptyState = () => {
  const navigate = useNavigate();

  return (
    <div className="flex background-none flex-col items-center justify-center py-16 px-4">
      <h3 className="text-xl font-semibold text-gray-900 mb-2">
        Your feed is empty, for now.
      </h3>
      <p className="text-gray-500 text-center mb-6 max-w-sm">
        Explore, follow creators you love, and let your feed write itself.
      </p>
      <a 
        onClick={() => navigate("/explore")}
        className="px-6 py-2.5 bg-gradient-to-r bg-[#b0d284] text-black rounded-lg font-medium hover:shadow-lg transition-all text-sm cursor-pointer"
      >
        Discover People
      </a>
    </div>
  );
};

export default EmptyState;